/**
 * Permissions from environment.ts file
 */
export enum EnvironmentPermission {
  DASHBOARD = 'dashboard',
  CLUB_ALBUM = 'clubAlbum',
  USERS = 'usersShow',
  LIVE_SHOW = 'liveShow',
  RECORDERS_SCHEDULE_SHOW = 'recordersScheduleShow',
  VIDEO_SHOW = 'videoShow',
  PLAYERS_SHOW = 'playersShow',
  MATCH_SHOW = 'matchShow',
  UPLOAD_REQUEST = 'uploadRequest',
  EVENTS_SHOW_SCHEMA = 'eventsShowSchema',
  PLAYLISTS_SHOW = 'playlistsShow',
}
